import { ZkMeWidget } from "@zkmelabs/widget";
import { fetchKycToken, pvzwebUserKycInfo } from "./method";
import lib from "@/common/rabby";
import { emitter, Events } from "./mitt";

let walletAddress = "";
const provider = {
  async getAccessToken() {
    // -------------------------TODO-------------------------
    // Request a new token from your backend service and return it to the widget.
    // For the access token, see docs.zk.me/zkme-dochub/verify-with-zkme-protocol/integration-guide/javascript-sdk/zkkyc-compliance-suite#how-to-generate-an-access-token-with-api_key
    // ------------------------------------------------------

    const {
      data: { data: result },
    } = await fetchKycToken({
      apiKey: "dc87e25a.41e0990de8ab8fc7eef52ab66eb92801",
      appId: "M2025032580451000180086025244040",
      apiModePermission: 0,
      lv: 1,
    });
    return result.accessToken;
  },

  async getUserAccounts() {
    // -------------------------TODO-------------------------
    // If your project is a Dapp,
    // you need to return the user's connected wallet address.
    const userConnectedAddress = walletAddress;
    return [userConnectedAddress];

    // If not,
    // you should return the user's e-mail address, phone number or any other unique identifier.
    //
    // return ['email address']
    // or
    // return ['phone number']
    // or
    // return ['unique identifier']
    // ------------------------------------------------------
  },
  // EVM
  async delegateTransaction(tx) {
    console.log("delegateTransaction", tx);
    let txResponse = await lib.sendTransaction(tx);
    return txResponse.hash;
  },
};

const zkMeWidget = new ZkMeWidget(
  // -------------------------TODO-------------------------
  "M2025032580451000180086025244040", // This parameter means the same thing as "mchNo"
  "Zombie",
  "0x89", // chainId. No changes are needed here if the account is configured for cross-chain.
  provider,
  {
    lv: "zkKYC",
    // For other options, please refer to the table below
  }
  // ------------------------------------------------------
);

function handleFinished(results) {
  console.log("User has completed zkKYC handleFinishedhandleFinished", results);
  const { isGrant, associatedAccount } = results;
  console.log("User has completed zkKYC verification", results);

  if (isGrant && associatedAccount === this.walletAddress.toLowerCase()) {
    console.log("User has completed zkKYC verification");
    pvzwebUserKycInfo().then((res) => {
      console.log("pvzwebUserKycInfo", res);
      emitter.emit(Events.Refresh_Account_Info, res);
    });
    // -------------------------TODO-------------------------
    // Prompts the user that zkKYC verification has been completed
    // ------------------------------------------------------
  }
}

zkMeWidget.on("kycFinished", handleFinished);

export function refreshWalletAddress(address) {
  walletAddress = address;
}

export function launch() {
  zkMeWidget.launch();
}
